import { IStepRequest } from './job-request.model';

export class FolderUploadStepRequest implements IStepRequest {
	stepFunctionType = 'folder-upload' as const;
	stepParams: { uploadBatchId: string, fileServer: 'amazon' | 'austin', folderPath: string, onlyNewFiles: boolean } = { uploadBatchId: null, fileServer: 'austin', onlyNewFiles: false, folderPath: null };
}

